import SiteLayout from "@/components/site/SiteLayout";
import { useAuth } from "@/lib/auth";
import { toast, Toaster } from "sonner";
import { Copy, Share2, DollarSign, UserPlus } from "lucide-react";
import { BRAND } from "@/config/brand";
import { Link } from "react-router-dom";
import useSeo from "@/lib/useSeo";

export default function Refer() {
  useSeo({
    title: `Refer & Earn — Give $${BRAND.referralBonusNew}, Get $${BRAND.referralBonusReferrer} | GC Nexon`,
    description: `Share GC Nexon and earn cash for every friend who sells their first gift card. They get $${BRAND.referralBonusNew} welcome credit, you get $${BRAND.referralBonusReferrer}.`,
    path: "/refer",
  });
  const { user } = useAuth();
  const shareUrl = user ? `${window.location.origin}/signup?ref=${user.referral_code}` : "";

  return (
    <SiteLayout>
      <Toaster richColors position="top-center" />
      <section className="section-py container-x">
        <span className="inline-block px-4 py-1.5 rounded-full bg-primary/10 text-primary text-xs font-bold uppercase mb-4">Refer & earn</span>
        <h1 className="text-5xl md:text-6xl font-extrabold tracking-tight max-w-3xl">Give ${BRAND.referralBonusNew}. Get ${BRAND.referralBonusReferrer}.</h1>
        <p className="mt-4 text-muted-foreground text-lg max-w-xl">Your friend sells a card, you both cash in. There's no limit.</p>

        <div className="mt-10 grid md:grid-cols-3 gap-6">
          {[
            { icon: Share2, t: "1. Share your link", d: "Every account gets a unique referral code." },
            { icon: UserPlus, t: "2. Friend signs up", d: `They get $${BRAND.referralBonusNew} welcome credit on their first sale.` },
            { icon: DollarSign, t: "3. You get $10", d: "Once their first submission is paid, we credit your wallet." },
          ].map((s, i) => (
            <div key={i} className="card-soft">
              <div className="w-11 h-11 rounded-2xl bg-primary/10 text-primary flex items-center justify-center"><s.icon size={20} /></div>
              <h3 className="mt-4 font-extrabold text-xl">{s.t}</h3>
              <p className="text-muted-foreground mt-2">{s.d}</p>
            </div>
          ))}
        </div>

        {user ? (
          <div className="mt-10 card-soft" data-testid="refer-panel">
            <h3 className="font-extrabold text-2xl">Your unique link</h3>
            <div className="mt-4 flex flex-col md:flex-row gap-3">
              <input readOnly value={shareUrl} className="flex-1 rounded-2xl border border-border bg-white px-4 py-3 font-mono text-sm" data-testid="refer-link" />
              <button onClick={() => { navigator.clipboard.writeText(shareUrl); toast.success("Copied"); }} className="btn-pill text-sm" data-testid="refer-copy"><Copy size={14} className="mr-2" /> Copy</button>
            </div>
            <div className="mt-4 text-sm text-muted-foreground">Current wallet credit: <strong className="text-primary">${(user.balance_credit||0).toFixed(2)}</strong></div>
          </div>
        ) : (
          <div className="mt-10 card-soft text-center">
            <p className="text-muted-foreground">Create an account to get your unique referral link.</p>
            <Link to="/signup" className="btn-pill mt-4 inline-flex text-sm">Sign up</Link>
          </div>
        )}
      </section>
    </SiteLayout>
  );
}
